<template>
    <client-page>
        <v-container>
            <div class="tit-wrap text-center">
                <h2 class="tit tit--lg">Forms &amp; Archives</h2>
            </div>

            <router-view name="board" code="forms" skin="attachment" hide-write-button v-bind="{ category }" />
        </v-container>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";

export default {
    components: {
        ClientPage,
    },
    computed: {
        category() {
            return this.$route.query.category || undefined;
        },
    },
};
</script>
